// extracted by mini-css-extract-plugin
module.exports =  {"evaluator":"Competency-stFK__evaluator","archived-competency":"Competency-iP9p__archived-competency","title":"Competency-EAWO__title","footer":"Competency-m21e__footer"};